/**
 * Hospitals domain — utility functions and shared types.
 *
 * Re-exports generated entity types plus the typed adapters that bridge the
 * Kubb-generated shapes to the legacy props expected by `DECommonTable`,
 * `DemographicsSection`, etc. The cross-domain adapters live here (rather
 * than in component files) so the casts are documented and centralized.
 */

import type { AddressInfo } from '../../models/restaurant'
import type { HospitalNested } from '../generated/types/HospitalNested'

// ── Domain entity type re-exports ───────────────────────────────────

export type { HospitalListItem } from '../generated/types/HospitalListItem'
export type { HospitalNested } from '../generated/types/HospitalNested'

// ── Typed adapters for legacy component props ───────────────────────

/**
 * Convert the generated `HospitalNested.address_info` (a `VerticalZipCode`
 * shape) into the legacy `AddressInfo` interface that `DemographicsSection`
 * accepts.
 *
 * `models/restaurant.AddressInfo` declares every demographic field as
 * required & non-null; the generated `VerticalZipCode` correctly types them
 * as optional. `DemographicsSection` already defends against missing fields,
 * so the runtime data is compatible. This helper makes the type bridge
 * explicit instead of forcing every call site to repeat the cast.
 */
export function toLegacyAddressInfo(
  addressInfo: HospitalNested['address_info'] | null | undefined
): AddressInfo | undefined {
  if (!addressInfo) return undefined
  return addressInfo as AddressInfo
}
